module.exports = __webpack_public_path__ + "img/cover2.111409f2.png";